var shopCommon = {
	adyen: {
		clientKey: "test_ORNCOIYKLJGFROSKKDM267OYGMGFV4XV"
	}
};
var zooplus = {
	paypal: {
		clientId: "AXUEaRugQt75OsjbNBy_8j7p9RIkOSN8X-ztrPsC1o0S5-MI6L6TTfZFAVPh7nRfoe1UNKe39MqDTC7Y"
	},
	optimizely: {
		clientId: "VL3ZuyRLa1uxV5P3dizQX"
	},
	bancontact: {
		adyenScriptSrc: "https://checkoutshopper-test.adyen.com/checkoutshopper/utility/v1/cse/js/7814684217730012.shtml",
		adyenScriptIntegrity: "sha-384-02zpQEBq9WtqUY/j/a+xxxNpnZf6K7i0SRnNhok5BX9qRiZ6oAs7KWw1LmW0zpEb"
	}
};
var bitiba = {
	paypal: {
		clientId: "AdvfaDLwMyN4Ippe9F1LDPseAm5xuStbwY6TeIyWIQyyDS32f9_D1TfKplM-OwETfeqDDOr7D3AUk0Tu"
	},
	optimizely: {
		clientId: "VL3ZuyRLa1uxV5P3dizQX"
	},
	bancontact: {
		adyenScriptSrc: "https://checkoutshopper-test.adyen.com/checkoutshopper/utility/v1/cse/js/7814684217730012.shtml",
		adyenScriptIntegrity: "sha-384-02zpQEBq9WtqUY/j/a+xxxNpnZf6K7i0SRnNhok5BX9qRiZ6oAs7KWw1LmW0zpEb"
	}
};
var devConfig = {
	shopCommon: shopCommon,
	zooplus: zooplus,
	bitiba: bitiba
};

export { bitiba, devConfig as default, shopCommon, zooplus };
//# sourceMappingURL=dev.json.js.map
